import { render, staticRenderFns } from "./diversity.vue?vue&type=template&id=25e88b08&"
import script from "./diversity.vue?vue&type=script&lang=js&"
export * from "./diversity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports